const INVALID_FILENAME_CHARS = /[\\/:*?"<>|]/g;

export const sanitizeDownloadFileName = (value, fallback = 'download') => {
  const safeName = String(value || '')
    .replace(INVALID_FILENAME_CHARS, '_')
    .split('')
    .map((char) => (char.charCodeAt(0) < 32 ? '_' : char))
    .join('')
    .replace(/\s+/g, ' ')
    .trim();
  return safeName || fallback;
};

export const supportsSaveFilePicker = () =>
  typeof window !== 'undefined' && typeof window.showSaveFilePicker === 'function';

export const isSavePickerAbortError = (error) =>
  error?.name === 'AbortError' || error?.code === 20;

export const requestSaveFileHandle = async (fileName, { fallback = 'download' } = {}) => {
  if (!supportsSaveFilePicker()) return null;
  return window.showSaveFilePicker({
    suggestedName: sanitizeDownloadFileName(fileName, fallback),
  });
};

export const writeBlobToFileHandle = async (handle, blob) => {
  if (!handle || !blob) return;
  const writable = await handle.createWritable();
  try {
    await writable.write(blob);
  } finally {
    await writable.close();
  }
};
